// test1481
(1481 && 0);
